import { vars } from 'src/core/themes';

import { PosIconProps, SvgWrapper } from '../SvgWrapper';

export const ClubLodgeBoxIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper
      {...props}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.6002 18.4C33.6002 12.6563 28.944 8.00005 23.2002 8.00005H16.8002C11.0564 8.00005 6.4002 12.6563 6.4002 18.4V21.6C6.4002 27.3438 11.0564 32 16.8002 32H23.2002C28.944 32 33.6002 27.3438 33.6002 21.6V18.4ZM36.8002 21.6C36.8002 29.1111 30.7113 35.2 23.2002 35.2H16.8002C9.28912 35.2 3.2002 29.1111 3.2002 21.6V18.4C3.2002 10.889 9.28912 4.80005 16.8002 4.80005H23.2002C30.7113 4.80005 36.8002 10.889 36.8002 18.4V21.6Z"
        fill={vars.color.textSecondaryV2}
      />
      <path
        d="M28.8002 18.4C28.8002 15.3073 26.293 12.8 23.2002 12.8H16.8002C13.7074 12.8 11.2002 15.3073 11.2002 18.4V21.6C11.2002 24.6928 13.7074 27.2 16.8002 27.2H23.2002C26.293 27.2 28.8002 24.6928 28.8002 21.6V18.4ZM32.0002 21.6C32.0002 26.4602 28.0603 30.4 23.2002 30.4H16.8002C11.9401 30.4 8.0002 26.4602 8.0002 21.6V18.4C8.0002 13.5399 11.9401 9.60005 16.8002 9.60005H23.2002C28.0603 9.60005 32.0002 13.5399 32.0002 18.4V21.6Z"
        fill={vars.color.textSecondaryV2}
      />
      <path
        d="M24.0002 18.4C24.0002 17.9582 23.642 17.6 23.2002 17.6H16.8002C16.3584 17.6 16.0002 17.9582 16.0002 18.4V21.6C16.0002 22.0419 16.3584 22.4 16.8002 22.4H23.2002C23.642 22.4 24.0002 22.0419 24.0002 21.6V18.4ZM27.2002 21.6C27.2002 23.8092 25.4093 25.6 23.2002 25.6H16.8002C14.5911 25.6 12.8002 23.8092 12.8002 21.6V18.4C12.8002 16.1909 14.5911 14.4 16.8002 14.4H23.2002C25.4093 14.4 27.2002 16.1909 27.2002 18.4V21.6Z"
        fill={vars.color.textSecondaryV2}
      />
      <path
        d="M10.0403 6.5964C10.7784 6.17278 11.6932 6.5179 12.065 7.28344C12.464 8.10513 12.0813 9.08479 11.3062 9.56801C9.46569 10.7153 8.0099 12.4218 7.17654 14.4499C6.8365 15.2774 5.96649 15.8164 5.10021 15.5928C4.256 15.3749 3.73363 14.5154 4.03512 13.6973C5.14517 10.6853 7.29084 8.17436 10.0403 6.5964Z"
        fill={vars.color.textPrimaryV2}
      />
      <path
        d="M10.0403 33.4038C10.7784 33.8274 11.6932 33.4823 12.065 32.7168C12.464 31.8951 12.0813 30.9154 11.3062 30.4322C9.46569 29.2849 8.0099 27.5784 7.17654 25.5503C6.8365 24.7228 5.96649 24.1838 5.10021 24.4074C4.256 24.6253 3.73363 25.4848 4.03512 26.3029C5.14517 29.3149 7.29084 31.8258 10.0403 33.4038Z"
        fill={vars.color.textPrimaryV2}
      />
      <path
        d="M29.9601 6.5964C29.222 6.17278 28.3072 6.5179 27.9354 7.28344C27.5363 8.10513 27.919 9.08479 28.6942 9.56801C30.5347 10.7153 31.9904 12.4218 32.8238 14.4499C33.1638 15.2774 34.0339 15.8164 34.9001 15.5928C35.7443 15.3749 36.2667 14.5154 35.9652 13.6973C34.8552 10.6853 32.7095 8.17436 29.9601 6.5964Z"
        fill={vars.color.textPrimaryV2}
      />
      <path
        d="M29.9601 33.4038C29.222 33.8274 28.3072 33.4823 27.9354 32.7168C27.5363 31.8951 27.919 30.9154 28.6942 30.4322C30.5347 29.2849 31.9904 27.5784 32.8238 25.5503C33.1638 24.7228 34.0339 24.1838 34.9001 24.4074C35.7443 24.6253 36.2667 25.4848 35.9652 26.3029C34.8552 29.3149 32.7095 31.8258 29.9601 33.4038Z"
        fill={vars.color.textPrimaryV2}
      />
    </SvgWrapper>
  );
};
